// extracted by mini-css-extract-plugin
export default {"title":"title-a8bfeU6g","body":"body-FNht3WYk","buttonIcon":"buttonIcon-B0hH1yw0"};